import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';
import { TabulkovaPozice } from '../tabulkovaPozice';

class OdhadyPracnostiProvider extends BaseApi {
	schemaUrl(tableName: string) {
		return `/${this.area}/${tableName}/Schema`;
	}

	tableUrl(tableName: string) {
		return `/${this.area}/${tableName}`;
	}

	async fetchTabulkovaPozice(data: any): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/${TabulkovaPozice.name}`, data);
	}

	async klon(ppodhadId: number, tablPozice: number[]): Promise<Record<string, any>> {
		return this.post(`${this.apiPath}Klon?ppodhadId=${ppodhadId}`, tablPozice);
	}
}

export const apiProvider = new OdhadyPracnostiProvider(DMS_MODULE, NAME);
